import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtModalInputTitle({ style, ...otherProps }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return <NtText style={[styles.text, style]} {...otherProps} />;
}

const makeStyles = (t) =>
  StyleSheet.create({
    text: {
      fontSize: 11,
      fontWeight: "600",
      color: t.textMute,
      textTransform: "uppercase",
      letterSpacing: 0.4,
    },
  });

export default NtModalInputTitle;
